import { sendToURL } from 'amkit3-modules/utils/ajax'
import { STATISTIC_CDNSTATS } from 'amkit3-modules/utils/services/urls'

export const cdncv_playinfo = (cdn, vid, url, error_msg, status, remark) => {
  sendToURL(STATISTIC_CDNSTATS, {
    r: 'cdncv/playinfo',
    cdn,
    vid,
    url,
    error_msg,
    status,
    remark,
  })
}

export const cdn_playstatus = (cdn, status, remark) => {
  sendToURL(STATISTIC_CDNSTATS, {
    r: 'cdn/playstatus',
    cdn,
    status,
    remark,
  })
}
export default {
  cdncv_playinfo,
  cdn_playstatus,
}
